/** Minimal YAML frontmatter parser for SKILL.md (single-line key: value pairs). */
export function parseSkillFrontmatter(skillMd: string): { meta: Record<string, string>; body: string } {
  const text = skillMd.replace(/^\uFEFF/, '')
  if (!text.startsWith('---')) {
    return { meta: {}, body: skillMd }
  }
  const rest = text.slice(3).replace(/^\n/, '')
  const end = rest.indexOf('\n---')
  if (end === -1) {
    return { meta: {}, body: skillMd }
  }
  const fmBlock = rest.slice(0, end)
  const body = rest.slice(end + 4).replace(/^\n/, '')
  const meta: Record<string, string> = {}
  for (const line of fmBlock.split('\n')) {
    const m = line.match(/^([A-Za-z0-9_-]+):\s*(.*)$/)
    if (m) meta[m[1]] = (m[2] || '').trim()
  }
  return { meta, body }
}

export function splitKeywords(raw: string | undefined): string[] {
  if (!raw?.trim()) return []
  return raw
    .split(/[,;]/)
    .map(s => s.trim())
    .filter(Boolean)
    .slice(0, 24)
}
